import { render, staticRenderFns } from "./PhotoUploadSlot.vue?vue&type=template&id=537cfa54&scoped=true&"
import script from "./PhotoUploadSlot.vue?vue&type=script&lang=js&"
export * from "./PhotoUploadSlot.vue?vue&type=script&lang=js&"
import style0 from "./PhotoUploadSlot.vue?vue&type=style&index=0&id=537cfa54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537cfa54",
  null
  
)

export default component.exports